import PropTypes from "prop-types";

const BackgroundImage = (props) => {
	const bgStyle = {
		height: props.height,
		width: props.width,
		margin: props.margin,
		padding: props.padding,
		backgroundSize: props.backgroundSize,
		backgroundRepeat: props.backgroundRepeat,
		backgroundPosition: props.backgroundPosition
	};

	const bgStyleExternal = {
		backgroundImage: `url(${props.imgSrcExternal})`
	};

	const bgStyleLocal = {
		backgroundImage: `url(${props.imgSrcLocal})`
	};

	const getStyles = () => {
		if (props.imgSrcExternal) {
			return bgStyleExternal;
		}
		if (props.imgSrcLocal) {
			return bgStyleLocal;
		}
	};

	return (
		<div style={{ ...bgStyle, ...getStyles() }}>
			{props.children}
		</div>
	);
};

BackgroundImage.propTypes = {
	height: PropTypes.string,
	width: PropTypes.string,
	imgSrcExternal: PropTypes.string,
	imgSrcLocal: PropTypes.string,
	margin: PropTypes.string,
	padding: PropTypes.string,
	backgroundSize: PropTypes.string,
	backgroundRepeat: PropTypes.string
};

BackgroundImage.defaultProps = {
	height: "100%",
	width: "100%",
	imgSrcExternal: "",
	imgSrcLocal: "",
	margin: "0",
	padding: "0",
	backgroundSize: "contain",
	backgroundRepeat: "no-repeat"
};

export default BackgroundImage;
